import { prospectApi } from './consts';
import { tokenHeader, getUserToken } from "./user-service";

const apiEndPoint = prospectApi;
// const sendApiEndPoint = sendMailApi;
// const apiSeqEndPoint = 'http://localhost:4000/api/prospects-seq';

export var getProspects = () => {
    return fetch(apiEndPoint, {
            headers: {
                [tokenHeader]: getUserToken()
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var getProspectsById = (id) => {
    return fetch(apiEndPoint + '/' + id, {
            headers: {
                [tokenHeader]: getUserToken()
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var getAllProspects = () => {
    return fetch(apiEndPoint + '/all', {
            headers: {
                [tokenHeader]: getUserToken()
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var getProspectsByUser = (assignedUser) => {
    return fetch(apiEndPoint + '/prospect-by-user/' + assignedUser, {
            headers: {
                [tokenHeader]: getUserToken()
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}


export var searchProspects = (field, searchText, user) => {
    return fetch(apiEndPoint + '/' + user + '/' + field + '/' + searchText, {
            headers: {
                [tokenHeader]: getUserToken()
            }
        })
        .then(res => res.json())
        .then((result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var getType = (type,user) => {
    return fetch(apiEndPoint + '/' + user + '/select-type/' + type, {
            headers: {
                [tokenHeader]: getUserToken()
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var dateFormat = (dateStr) => {
    let date = new Date(dateStr);
    return date.toLocaleString();
}